export function isObjectEmpty(obj: Record<string, unknown>): boolean {
    return (
        Object.keys(obj).length === 0 || Object.values(obj).every((value) => value === undefined)
    );
}

export function omit<T extends object, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> {
    const result: T = { ...obj };

    for (const key of keys) {
        delete result[key];
    }

    return result;
}

export function pick<T extends object, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> {
    const result = {} as Pick<T, K>;

    for (const key of keys) {
        result[key] = obj[key];
    }

    return result;
}

export function replaceUndefinedWithNull<T extends object>(obj: T): void {
    // Check if the current item is an array
    if (Array.isArray(obj)) {
        // Iterate over each item in the array
        for (let i = 0; i < obj.length; i++) {
            // Replace undefined with null if the item is undefined
            if (obj[i] === undefined) {
                obj[i] = null;
            } else if (typeof obj[i] === 'object' && obj[i] !== null) {
                // Recursively call the function if the item is an object or array
                replaceUndefinedWithNull(obj[i]);
            }
        }
    } else if (typeof obj === 'object' && obj !== null) {
        // Iterate over each key in the object
        for (const key in obj) {
            if (Object.hasOwn(obj, key)) {
                // Replace undefined with null if the property is undefined
                if (obj[key] === undefined) {
                    //@ts-expect-error - Type could be instanciated...
                    obj[key] = null;
                } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                    // Recursively call the function if the property is an object or array
                    replaceUndefinedWithNull(obj[key]);
                }
            }
        }
    }
}
